// extracted by mini-css-extract-plugin
export var orderSummary = "_jg-0";
export var showMoreLessButton = "_jg-1";